import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { on_user_leave_from_entity, try_update_viewed_entity } from '@/utils/utils_client_workspace_child_entity_viewers';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { useRef } from 'react';

export function WatcherViewEntityUserTaskGeneration() {
  const { generation_current } = use_slice_generation(['generation_current']);

  const ref_entity = useRef(DTO__generation.CREATE_STUB());

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (ref_entity.current._id === generation_current._id) return;

    ref_entity.current = generation_current;

    void try_update_viewed_entity(generation_current);

    return () => {
      if (ref_entity.current.is_stub()) return;
      if (ref_entity.current._id === generation_current._id) return;

      void on_user_leave_from_entity(ref_entity.current._id, ref_entity.current.type);
    };
  }, [generation_current]);

  return <></>;
}
